export default __webpack_public_path__ + "static/ch01-5ab445226241d04e534a9a72a0d9f795.png";